/* eslint-disable sonarjs/cognitive-complexity */
import {
  BaSeBreakpointContext,
  BaSeIcon,
  BaSeLogoSebraeInverse,
  BaSeSmall1,
  BaSeSmall2,
  BaSeTheme,
} from '@base/react';
import * as React from 'react';
import appStore from '../../assets/appstore.svg';
import facebookSvg from '../../assets/facebook.svg';
import instaSvg from '../../assets/instagram.svg';
import linkedinSvg from '../../assets/linkedin.svg';
import empretecRodape from '../../assets/logo-rodape.png';
import playStore from '../../assets/play-store.svg';
import twitters from '../../assets/twitter-icon.svg';
import youtubeSvg from '../../assets/youtube.svg';
import {
  AlignCenter,
  AlignLogoSebraeFooter,
  AlignStores,
  Container,
  ContainerMedias,
  Content,
  ContentCentralRelacionamento,
  Wraper,
  WraperCentralRelations,
} from './style';

export const Footer = () => {
  const breakpointController = React.useContext(BaSeBreakpointContext);

  const listItens = React.useCallback(
    () => [
      {
        id: 4,
        link: 'https://www.youtube.com/sebrae',
        iconName: 'logos/youtube-line',
        iconSvg: youtubeSvg,
      },
      {
        id: 5,
        link: 'https://www.linkedin.com/company/sebrae',
        iconName: 'linkedin-alt-solid',
        iconSvg: linkedinSvg,
      },
      {
        id: 6,
        link: 'https://www.facebook.com/sebrae',
        iconName: 'facebook-f',
        iconSvg: facebookSvg,
      },
      {
        id: 7,
        link: 'https://twitter.com/sebrae',
        iconName: 'twitter',
        iconSvg: twitters,
      },
      {
        id: 8,
        link: 'https://www.instagram.com/sebrae',
        iconName: 'logos/instagram-line',
        iconSvg: instaSvg,
      },
    ],
    [],
  );

  const listStores = React.useCallback(
    () => [
      {
        id: 1,
        link: 'https://play.google.com/store/apps/details?id=br.com.sebrae.napalmadam',
        iconName: 'google-play',
        iconSvg: playStore,
      },
      {
        id: 2,
        link: 'https://apps.apple.com/br/app/sebrae/id1482839375',
        iconName: 'logos/apple-line',
        iconSvg: appStore,
      },
    ],
    [],
  );

  return (
    <Container>
      <Content>
        <Wraper>
          <WraperCentralRelations>
            <img src={empretecRodape} alt="logoempretec no rodape" />
            <ContentCentralRelacionamento>
              <p>Central de Relacionamento</p>
              <strong>0800 570 0800</strong>
            </ContentCentralRelacionamento>
          </WraperCentralRelations>
          <ContainerMedias>
            <AlignStores img={playStore}>
              <BaSeSmall1 color={BaSeTheme.colors.defaultColors.white}>
                Baixe o App Sebrae:
              </BaSeSmall1>

              {listStores().map((item) => {
                return (
                  <a
                    href={item.link}
                    // eslint-disable-next-line react/jsx-no-target-blank
                    target="_blank"
                  >
                    <img src={item.iconSvg} alt="logo aple store" />
                  </a>
                );
              })}
            </AlignStores>
            {breakpointController.inDesktop && (
              <BaSeIcon
                color="#fff"
                description="Ícone de stores"
                name={'character/alegreya-sans/bar'}
                size={20}
              />
            )}

            <AlignStores>
              {listItens().map((item) => {
                return (
                  // eslint-disable-next-line react/jsx-no-target-blank
                  <a href={item.link} target="_blank">
                    <img src={item.iconSvg} alt="logo titter" />
                  </a>
                );
              })}
            </AlignStores>

            <AlignLogoSebraeFooter>
              <a
                href="https://sebrae.com.br/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <BaSeLogoSebraeInverse width={'60px'} />
              </a>
            </AlignLogoSebraeFooter>
          </ContainerMedias>
        </Wraper>
      </Content>
      <AlignCenter>
        <BaSeSmall2 color={BaSeTheme.colors.defaultColors.white}>
          Empretec © 2024. Todos os direitos reservados
        </BaSeSmall2>
      </AlignCenter>
    </Container>
  );
};
